module.exports = __webpack_public_path__ + "img/page_bg_smartAds.c236cc57.png";